export function getRelativeUrl(wordpressUrl: string): string {
    return wordpressUrl.replace(process.env.GATSBY_WP_SITE_URL!, '').replace('/home/', '/');
}

export function getCorrectSolutionUrl(solutionUrl: string) : string {
    return solutionUrl.replace('/solutions/', '').replace('/', '')
}